import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

export const TICKER_PAGES = [
  { path: "/events", label: "Events" },
  { path: "/leaderboards", label: "Leader Boards" },
  { path: "/results", label: "Results" },
  { path: "/where-to-play", label: "Where to Play" },
  { path: "/about", label: "About" },
];

export default function SiteTicker() {
  const { pathname } = useLocation();
  const [ticker, setTicker] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setTicker(r.data?.home?.ticker || null)).catch(() => {});
  }, []);

  if (!ticker) return null;
  const items = (ticker.items || []).filter(Boolean);
  const show = pathname === "/" ? ticker.enabled : (ticker.pages || []).includes(pathname);
  if (!show || items.length === 0) return null;

  return (
    <div className="bg-gold overflow-hidden" data-testid="home-ticker">
      <div className="whitespace-nowrap py-2 flex" style={{ animation: `lp-ticker ${Math.max(5, Number(ticker.speed) || 30)}s linear infinite` }}>
        {items.concat(items).map((t, i) => (
          <span key={i} className="mx-8 text-navy text-sm font-bold uppercase tracking-widest">★ {t}</span>
        ))}
      </div>
      <style>{`@keyframes lp-ticker{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}`}</style>
    </div>
  );
}
